import { Input } from 'antd';

interface CodeInputProps {
  value?: string;
  onChange?: (value: string) => void;
  /** Fired once every box holds a digit. Wire the submit here. */
  onComplete?: (value: string) => void;
  /** Defaults to six. The authenticator enrolment takes it from the server's `digits`. */
  length?: number;
  disabled?: boolean;
  autoFocus?: boolean;
  status?: '' | 'error' | 'warning';
}

/**
 * The digit code entry, shared by password recovery, the sign-in challenge and both
 * two-factor enrolments: the same interaction four times.
 *
 * Built on antd's `Input.OTP` so paste works without any handling of our own, and so the value
 * stays a **string**: leading zeros are significant and a numeric input would eat them.
 * `Input.OTP` fires `onChange` only once every box is filled, which is the auto-submit hook;
 * `onInput` fires on each keystroke and carries the per-box array.
 */
const CodeInput = ({
  value,
  onChange,
  onComplete,
  length = 6,
  disabled,
  autoFocus,
  status
}: CodeInputProps) => (
  <Input.OTP
    length={length}
    size="large"
    value={value}
    disabled={disabled}
    autoFocus={autoFocus}
    status={status}
    inputMode="numeric"
    // Strip anything that is not a digit, so a pasted "048 213" or "code: 048213" still lands.
    formatter={(text) => text.replace(/\D/g, '')}
    onInput={(boxes) => onChange?.(boxes.join(''))}
    onChange={(text) => {
      onChange?.(text);
      if (text.length === length) onComplete?.(text);
    }}
  />
);

export default CodeInput;
